import { render, staticRenderFns } from "./EditUltrasound.vue?vue&type=template&id=fcaed672&scoped=true"
import script from "./EditUltrasound.vue?vue&type=script&lang=js"
export * from "./EditUltrasound.vue?vue&type=script&lang=js"
import style0 from "./EditUltrasound.vue?vue&type=style&index=0&id=fcaed672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcaed672",
  null
  
)

export default component.exports